import { motion } from "framer-motion";

// Split a string into words wrapped in a masked container for line-by-line reveals.
export const MaskedHeadline = ({ text, className = "", delayBase = 0 }) => {
  const words = text.split(" ");
  return (
    <span className={className}>
      {words.map((w, i) => (
        <span key={i} className="mask-line mr-[0.25em]">
          <motion.span
            initial={{ y: "110%" }}
            animate={{ y: "0%" }}
            transition={{
              duration: 1.05,
              ease: [0.77, 0, 0.18, 1],
              delay: delayBase + i * 0.06,
            }}
            className="inline-block"
          >
            {w}
          </motion.span>
        </span>
      ))}
    </span>
  );
};

export const RevealBlock = ({ children, delay = 0, y = 40, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 1, ease: [0.22, 1, 0.36, 1], delay }}
    className={className}
  >
    {children}
  </motion.div>
);

export const ClipReveal = ({ children, className = "", delay = 0 }) => (
  <motion.div
    initial={{ clipPath: "inset(0 0 100% 0)" }}
    whileInView={{ clipPath: "inset(0 0 0% 0)" }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 1.4, ease: [0.77, 0, 0.18, 1], delay }}
    className={className}
  >
    {children}
  </motion.div>
);
